import dayjs from 'dayjs'
import Badge from '../../../components/Badge/Badge'
import {
  INVITATION_CODE_ORIGIN,
  IS_ADMIN,
  IS_COMPANY,
  IS_HIRING_ADVISOR,
  IS_RECRUITER,
  IS_TALENT,
  NOT_AVAILABLE,
  TYPE_OF_USER,
  VIEWPORT_LG,
} from '../../../utils/constants'
import GlittersIcon from '../../../icons/fastoffer/GlittersIcon'
import Divider from '../../../components/Divider'
import MoneyIcon from '../../../icons/fastoffer/MoneyIcon'

import Button from '../../../components/Button'
import { Link, useNavigate } from 'react-router-dom'
import { copyClipboard, formatCurrency, transformDate } from '../../../utils'
import ArrowRigthIcon from '../../../icons/ArrowRigthIcon'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  acceptJobOffer,
  declineJobOffer,
  listOfReasonForDeclineJobOffer,
} from '../../../services/OfferManagement'
import Loader from '../../../components/Loader'
import Swal from 'sweetalert2'
import { TAGS } from '../../../services/Tags'
import ProgressStatusIcon from '../../../icons/ProgressStatusIcon'
import EarringStatusIcon from '../../../icons/EarringStatusIcon'
import useResize from '../../../hooks/useResize'
import { useForm } from 'react-hook-form'
import { typeUser } from '../../../localStorage'
import XDangerIcon from '../../../icons/XDangerIcon'
import DeclineJobOfferModal from './DeclineJobOfferModal'
import AssignCompanyModal from './AssignCompanyModal'
import ArrowPathIcon from '../../../icons/ArrowPathIcon'
import { PRIVATE_ROUTES } from '../../../Routes/routes'
import { useTranslation } from 'react-i18next'
import DownLoadIcon from '../../../icons/DownLoadIcon'
import Tooltip from '../../../components/Tooltip'
import {
  useGlobalProfileUserInfo,
  useTalentActiveProcessesStore,
} from '../../../store'
import { removeOffer, visibleOffer } from '../../../services/Admin'
import { sendContactInformation } from '../../../services/publicServices/sendContactInformation'
import Toast from '../../../components/Toast/Toast'
import DesactiveBadge from '../../../components/Badge/DesactiveBadge'
import ActiveBadge from '../../../components/Badge/ActiveBadge'
import BriefcaseClockIcon from '../../../icons/BriefcaseClockIcon'
import CalendarIcon from '../../../icons/CalendarIcon'
import ClockIcon from '../../../icons/ClockIcon'
import EyeIcon from '../../../icons/EyeIcon'
import PencilIcon from '../../../icons/PencilIcon'
import Circle from '../../../components/Circle'
import StoreIcon from '../../../icons/StoreIcon'
import HouseAndBuildingIcon from '../../../icons/HouseAndBuildingIcon'
import CashSmallIcon from '../../../icons/CashSmallIcon'
import { useGetProfileUserInfo } from '../../../hooks/useGetProfileUserInfo'
import hutrit_next_banner_icon from '../../../icons/hutrit_next_banner_icon.svg'
import MatchBadgeIcon from '../../../icons/MatchBadgeIcon'

//TODO: enable when update duplicate offer FIGMA.
// import ClipboardIcon from '../../../icons/ClipboardIcon'
// import WorkingOnItModal from '../../../components/Modals/WorkingOnItModal'

const initialValues = {
  idOffer: '',
  idReason: '',
}

const JobOfferCard = (props) => {
  const isJuniorView = props.isJuniorView
  const isFastofferHutritNext = props.isFastofferHutritNext
  const isFavoriteMatch = Number(props?.matchToday) >= 1

  const { setShowTalentActiveProcesses, setId: setOfferSubmissionId } =
    useTalentActiveProcessesStore()
  const queryClient = useQueryClient()
  const viewportSize = useResize()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const isMoreTwoTalents = props?.isMoreTwoTalents

  const { profileInfo: userData } = useGlobalProfileUserInfo()
  const { isLoading: userDataIsLoading } = useGetProfileUserInfo()
  const tmCode = userData?.userInfo?.recruiter_invitation_code?.code
  const {
    handleSubmit,
    setValue,
    register,
    formState: { errors },
  } = useForm(initialValues)

  const {
    company = {},
    offer = {},
    accept = false,
    expired = false,
    offer_status_id,
    offer_date = '',
    date_create = '',
    date_estimated_hiring = '',
    send = false,
    id,
  } = props

  const {
    offert_skills: company_offert_skills = [],
    position: company_position = '',
    starting_amount: company_starting_amount = '',
    final_amount: company_final_amount,
    id: offert_id,
    modality_offerts = [],
    address = {},
    visible = false,
    name: nameOffer,
    countTalentLinked,
    candidates = null,
    process_candidates = 0,
    process_id,
    coin: coinOutside,
    description = '',
  } = props.tabBarValue === 2 && IS_HIRING_ADVISOR ? props?.offer ?? {} : props

  const { company_sector = {}, name = '', logo = '' } = company || {}
  const hideTalentButtons = expired || offer_status_id === 2
  const showProcessButton = accept

  const {
    offert_skills = [],
    companies_simple = {},
    position = '',
    starting_amount = '',
    final_amount = 0,
    coin = {},
    active = true,
    modality_offerts: modality_offerts_talent = [],
    address: address_talent = {},
    category_job = {},
    hutrit_next = false,
  } = offer || {}
  const {
    company_sector: companies_simple_sector,
    name: companies_simple_name,
  } = companies_simple || {}

  const renderSkills = {
    [TYPE_OF_USER.talent]: offert_skills,
    [TYPE_OF_USER.recruiter]: company_offert_skills || [],
    [TYPE_OF_USER.company]: company_offert_skills || [],
    [TYPE_OF_USER.admin]: company_offert_skills || [],
    [TYPE_OF_USER.hiring_advisor]: company_offert_skills || [],
  }

  const renderPosition = {
    [TYPE_OF_USER.talent]: position ?? category_job?.name,
    [TYPE_OF_USER.recruiter]: props?.category_job?.name ?? company_position,
    [TYPE_OF_USER.company]: props?.category_job?.name ?? company_position,
    [TYPE_OF_USER.admin]: props?.category_job?.name ?? company_position,
    [TYPE_OF_USER.hiring_advisor]:
      props?.category_job?.name ?? company_position,
  }

  const renderStartingAmount = {
    [TYPE_OF_USER.talent]: starting_amount,
    [TYPE_OF_USER.recruiter]: company_starting_amount,
    [TYPE_OF_USER.company]: company_starting_amount,
    [TYPE_OF_USER.admin]: company_starting_amount,
    [TYPE_OF_USER.hiring_advisor]: company_starting_amount,
  }

  const renderFinalAmount = {
    [TYPE_OF_USER.talent]: final_amount,
    [TYPE_OF_USER.recruiter]: company_final_amount,
    [TYPE_OF_USER.company]: company_final_amount,
    [TYPE_OF_USER.admin]: company_final_amount,
    [TYPE_OF_USER.hiring_advisor]: company_final_amount,
  }

  const renderModalityOffer = {
    [TYPE_OF_USER.talent]: modality_offerts_talent,
    [TYPE_OF_USER.recruiter]: modality_offerts,
    [TYPE_OF_USER.company]: modality_offerts,
    [TYPE_OF_USER.admin]: modality_offerts,
    [TYPE_OF_USER.hiring_advisor]: modality_offerts,
  }

  const renderAdress = {
    [TYPE_OF_USER.talent]: address_talent,
    [TYPE_OF_USER.recruiter]: address,
    [TYPE_OF_USER.company]: address,
    [TYPE_OF_USER.admin]: address,
    [TYPE_OF_USER.hiring_advisor]: address,
  }

  const {
    data: listOfReasonForDeclineJobOfferData = [],
    isloading: isloadingListOfReasonForDeclineJobOffer,
  } = useQuery(
    [TAGS.reason_for_decline_job_offer],
    listOfReasonForDeclineJobOffer
  )

  const { mutate: removeOfferMutate, isLoading: isLoadingRemoveOffer } =
    useMutation(['remove-offer'], removeOffer, {
      onSuccess: ({ status }) => {
        if (status !== 200) {
          Toast({ icon: 'error', title: 'Error en el sistema' })
        } else {
          queryClient.invalidateQueries('remove-offer')
          Toast({ title: 'Oferta eliminada con exito' })
        }
      },
    })

  const totalElementsToShow = 2
  const showSkills = renderSkills?.[typeUser]?.length > 2

  const elementsToShow = renderSkills?.[typeUser]?.slice(0, totalElementsToShow)

  const offerDate = dayjs(offer_date)?.format('DD-MM-YYYY')
  const dateCreateOffer = dayjs(
    (props.tabBarValue === 2 && IS_HIRING_ADVISOR) || IS_TALENT
      ? offer_date
      : date_create
  )?.format('DD-MM-YYYY')
  const dateEstimatedHiring = dayjs(
    date_estimated_hiring ?? '2024-11-03T00:00:00.000Z'
  )?.format('DD-MM-YYYY')
  const today = dayjs().format('DD-MM-YYYY')

  const SkeletonToast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    },
  })

  const { mutate: acceptJobOfferMutate, isLoading: isLoadingAcceptJobOffer } =
    useMutation([TAGS.accept_job_offer], acceptJobOffer, {
      onSuccess: ({ status }) => {
        if (status === 200) {
          queryClient.invalidateQueries(TAGS.accept_job_offer)
          SkeletonToast.fire({
            icon: 'success',
            title: `La oferta para ${
              position ?? props?.category_job?.name
            } fue aceptada con éxito`,
          })
        }
      },
    })

  const { mutate: declineJobOfferMutate, isLoading: isLoadingDeclineJobOffer } =
    useMutation([TAGS.decline_job_offer], declineJobOffer, {
      onSuccess: ({ status }) => {
        if (status === 200) {
          queryClient.invalidateQueries(TAGS.decline_job_offer)
          SkeletonToast.fire({
            icon: 'success',
            title: `La oferta para ${
              position ?? props?.category_job?.name
            } fue rechazada con éxito`,
          })
        }
      },
    })

  const { mutate: visibleOfferMutate, isLoading: isLoadingVisibleOffer } =
    useMutation([TAGS.visible_offer], visibleOffer, {
      onSuccess: ({ status }) => {
        if (status === 200) {
          queryClient.invalidateQueries(TAGS.visible_offer)
          visible
            ? Toast({ title: 'Oferta ocultada correctamente' })
            : Toast({ title: 'La oferta ya es visible para los TM' })
        }
      },
    })

  const onSubmit = (data) => {
    declineJobOfferMutate({
      idOffer: id,
      idReason: data?.idReason?.[0],
    })
  }

  const handleAcceptJobOffer = () => {
    acceptJobOfferMutate({ idOffer: id })
  }

  const handleOnChange = (evt) => {
    const checkboxValue = evt.target.value
    setValue('idReason', checkboxValue)
  }

  const handleOpenDeclineJobOfferModal = () => {
    DeclineJobOfferModal({
      handleOnChange,
      onSubmit,
      handleSubmit,
      register,
      listOfReasonForDeclineJobOfferData,
      isloadingListOfReasonForDeclineJobOffer,
      isLoadingDeclineJobOffer,
      errors,
    })
  }

  const handleVisibleOffer = ({ id, visible, companyId }) => {
    if (visible) {
      visibleOfferMutate({
        offerId: id,
        visible: false,
        companyId,
      })
    } else {
      visibleOfferMutate({
        offerId: id,
        visible: true,
        companyId,
      })
    }
  }

  const handleCampaignClick = async () => {
    const campaignData = {
      'Nombre de la oferta': nameOffer || renderPosition[typeUser],
      'Nombre de la empresa': company?.name || company?.display_name || name,
      categoria: renderPosition[typeUser],
      habilidades: renderSkills[typeUser]
        ?.map((skill) => skill?.skills_categori?.skill?.name || skill?.name)
        .join(', '),
      'Rango salarial': `300$`,
      modalidad: renderModalityOffer[typeUser]?.[0]?.modality?.name || '',
      descripcion: description?.replace(/<[^>]*>/g, ''),
    }

    try {
      await sendContactInformation(campaignData, 'adamrrq1313@gmail.com')
      Toast({ title: 'Información de campaña enviada correctamente' })
    } catch (error) {
      console.error('Error al enviar información de campaña:', error)
      Toast({ title: 'Error al enviar información de campaña', type: 'error' })
    }
  }

  const renderButtons = {
    [TYPE_OF_USER.talent]: (
      <div className="d-flex justify-content-end align-items-center gap-3">
        {!hideTalentButtons && (
          <>
            {showProcessButton ? (
              <>
                <Button
                  className="d-flex btn-white text-on-bg-primary border border-on-bg-primary"
                  onClick={async () => {
                    await setOfferSubmissionId(id)
                    await setShowTalentActiveProcesses(true)

                    if (window.location.pathname === PRIVATE_ROUTES.dashboard) {
                      navigate('/list-of-offers')
                    }
                  }}
                >
                  <div className="d-flex align-items-center gap-2 font-small inline-text">
                    {t('see_processes')}
                  </div>
                </Button>
                <Button
                  onClick={() =>
                    navigate(
                      IS_ADMIN
                        ? `/offer-detail-admin/${offert_id}`
                        : `/offer-management/${id || offert_id}`
                    )
                  }
                >
                  <span className="font-small text-on-bg-primary">
                    {t('review_offer')}
                  </span>
                </Button>
              </>
            ) : (
              <>
                <Button
                  className="d-flex btn-white text-on-bg-primary border border-on-bg-primary"
                  disabled={isLoadingAcceptJobOffer || !active}
                  onClick={handleOpenDeclineJobOfferModal}
                >
                  <div className="d-flex align-items-center gap-2">
                    {t('decline')}
                  </div>
                </Button>
                <Button
                  onClick={handleAcceptJobOffer}
                  disabled={isLoadingAcceptJobOffer}
                  className="btn-bg-CTA-primary text-on-bg-primary"
                  type="button"
                >
                  {t('accept_now')}
                </Button>
              </>
            )}
          </>
        )}
      </div>
    ),
    [TYPE_OF_USER.recruiter]: (
      <div className="d-flex justify-content-end align-items-center gap-3">
        <Link
          className="btn border border-on-bg-primary"
          to={`/download-offer-view/${id}`}
          variant="secondary"
        >
          <div className="d-flex align-items-center gap-1 cursor-pointer">
            <DownLoadIcon fill="#004949" />
            <span className="text-on-bg-primary">{t('download')}</span>
          </div>
        </Link>
        <Button
          onClick={() =>
            navigate(
              IS_ADMIN
                ? `/offer-detail-admin/${offert_id}`
                : `/offer-management/${id || offert_id}`
            )
          }
        >
          <span className="font-small text-on-bg-primary">
            {t('review_offer')}
          </span>
        </Button>
      </div>
    ),
    [TYPE_OF_USER.company]: (
      <div className="d-flex justify-content-between align-items-center">
        <Badge className="bg-bg-CTA-primary-selected fst-normal font-small-3 text-on-bg-CTA-primary-selected rounded-pill p-2 d-flex align-items-center gap-1">
          {`${countTalentLinked ?? 0} ${t('candidates')}`}
        </Badge>
        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center gap-3">
            {/* <div
              title={t('duplicate_offer')}
              onClick={() => WorkingOnItModal()}
            >
              <ClipboardIcon
                fill="#6B8282"
                width="16"
                height="16"
                className="cursor-pointer"
              />
            </div> */}
            <div
              title={t('see_details')}
              onClick={() => {
                const renderNavigateRoute = isJuniorView
                  ? `/offer-juniors-detail/${id || offert_id}`
                  : `/offer-management/${id || offert_id}`
                navigate(renderNavigateRoute)
              }}
            >
              <EyeIcon
                fill="#6B8282"
                width="16"
                height="16"
                className="cursor-pointer"
              />
            </div>
            <div
              style={{
                opacity: send ? '0.5' : '',
              }}
              title={
                send
                  ? 'No puedes editar la oferta, ya que fue enviada'
                  : t('edit_offer')
              }
              onClick={() => {
                if (send) return
                if (!isJuniorView) {
                  navigate(`/edit-job-offer/${id || offert_id}`)
                } else {
                  navigate(`/edit-job-offer-hutrit-next/${id || offert_id}`)
                }
              }}
            >
              <PencilIcon
                fill="#6B8282"
                width="16"
                height="16"
                className="cursor-pointer"
              />
            </div>
          </div>
          <Button variant="secondary" onClick={handleCampaignClick}>
            <span className="font-small text-on-bg-primary">
              {t('campaign')}
            </span>
          </Button>
          <Button
            variant="secondary"
            onClick={() =>
              navigate(`/process/${process_id}/${id || offert_id}`, {
                state: isJuniorView ? 'isJuniorView' : '',
              })
            }
          >
            <span className="font-small text-on-bg-primary">
              {t('see_candidates')}
            </span>
          </Button>
        </div>
      </div>
    ),
    [TYPE_OF_USER.hiring_advisor]: (
      <div
        className={`d-flex ${
          viewportSize[0] <= VIEWPORT_LG
            ? 'flex-column align-items-stretch gap-2'
            : 'justify-content-between align-items-center'
        }`}
      >
        <Badge className="bg-bg-CTA-primary-selected fst-normal font-small-3 text-on-bg-CTA-primary-selected rounded-pill p-2 d-flex align-items-center gap-1"
          style={
            viewportSize[0] <= VIEWPORT_LG
              ? { width: 'max-content' }
              : undefined
          }
        >
          {`${
            process_candidates ??
            countTalentLinked ??
            candidates ??
            props?.candidates ??
            0
          } ${t('candidates')}`}
        </Badge>
        <div
          className={`d-flex align-items-center ${
            viewportSize[0] <= VIEWPORT_LG
              ? 'flex-wrap gap-2'
              : 'gap-3'
          }`}
        >
          <div className="d-flex align-items-center gap-3">
            <div
              style={{
                opacity: send ? '0.5' : '',
              }}
              title={
                send
                  ? 'No puedes editar la oferta, ya que fue enviada'
                  : t('edit_offer')
              }
              onClick={() => {
                if (send) return
                if (!isJuniorView) {
                  navigate(`/edit-job-offer/${id || offert_id}`)
                } else {
                  navigate(`/edit-job-offer-juniors/${id || offert_id}`)
                }
              }}
            >
              <PencilIcon
                fill="#6B8282"
                width="16"
                height="16"
                className="cursor-pointer"
              />
            </div>
            <div
              title={t('see_details')}
              onClick={() =>
                navigate(
                  `/offer-management/${
                    props.tabBarValue === 1 ? id || offert_id : props?.offer?.id
                  }`
                )
              }
            >
              <EyeIcon
                fill="#6B8282"
                width="16"
                height="16"
                className="cursor-pointer"
              />
            </div>
            <div
              title={t('assign_to_company') || 'Asignar a empresa'}
              data-bs-toggle="modal"
              data-bs-target={`#assignCompanyModal-${id || offert_id}`}
              className="cursor-pointer"
            >
              <ArrowPathIcon
                width="16"
                height="16"
                className="cursor-pointer text-on-bg-secondary"
              />
            </div>
          </div>
          <Button variant="secondary" onClick={handleCampaignClick}>
            <span className="font-small text-on-bg-primary">
              {t('campaign')}
            </span>
          </Button>
          <Button
            variant="secondary"
            onClick={() =>
              navigate(`/process/${company?.id}/${id || offert_id}`, {
                state: isJuniorView ? 'isJuniorView' : '',
              })
            }
          >
            <span className="font-small text-on-bg-primary">
              {t('see_candidates')}
            </span>
          </Button>
        </div>
      </div>
    ),
  }

  const renderModality = {
    1: (
      <div className="d-flex align-items-center gap-1">
        <HouseAndBuildingIcon fill="#004949" width={16} height={16} />
        <span className="text-on-bg-secondary font-small-2">Modalidad:</span>
        <span className="font-small-2 inline-text">
          ({renderModalityOffer?.[typeUser]?.[0]?.modality?.name})
        </span>

        <span className="font-small-2 inline-text">
          {renderAdress?.[typeUser]?.city?.city_name}
        </span>

        <Tooltip
          text={renderAdress?.[typeUser]?.country?.country_name}
          style={{
            zIndex: '3000',
          }}
        >
          <img
            className="rounded-circle"
            width={12}
            height={12}
            src={renderAdress?.[typeUser]?.country?.flag}
          />
        </Tooltip>
      </div>
    ),
    2: (
      <div className="d-flex align-items-center gap-1">
        <HouseAndBuildingIcon fill="#004949" width={16} height={16} />
        <span className="text-on-bg-secondary font-small-2">Modalidad:</span>
        <span className="font-small-2 inline-text">{t('remote')}</span>
      </div>
    ),
    3: (
      <div className="d-flex align-items-center gap-1">
        <HouseAndBuildingIcon fill="#004949" width={16} height={16} />
        <span className="text-on-bg-secondary font-small-2">Modalidad:</span>
        <span className="font-small-2 inline-text">
          ({renderModalityOffer?.[typeUser]?.[0]?.modality?.name})
        </span>

        <span className="font-small-2 inline-text">
          {renderAdress?.[typeUser]?.city?.city_name}
        </span>

        <Tooltip
          text={renderAdress?.[typeUser]?.country?.country_name}
          style={{
            zIndex: '3000',
          }}
        >
          <img
            className="rounded-circle"
            width={12}
            height={12}
            src={renderAdress?.[typeUser]?.country?.flag}
          />
        </Tooltip>
      </div>
    ),
  }

  return IS_COMPANY || IS_HIRING_ADVISOR ? (
    <>
      <div className="position-relative">
        {isLoadingAcceptJobOffer && (
          <div className="position-absolute bg-blur">
            <div className="position-absolute loader-containter">
              <Loader />
            </div>
          </div>
        )}
        <div
          style={{
            width:
              viewportSize[0] <= VIEWPORT_LG &&
              window.location.pathname === PRIVATE_ROUTES.list_of_offers
                ? '100%'
                : '',
            maxWidth:
              viewportSize[0] <= VIEWPORT_LG &&
              window.location.pathname === PRIVATE_ROUTES.list_of_offers
                ? '350px'
                : '',
            border: isFavoriteMatch ? '1px solid #407BFF' : '',
            background: isFavoriteMatch
              ? 'linear-gradient(57.13deg, #FFFFFF 0.58%, #E4ECFF 100%)'
              : '',
          }}
          className="hover-job-offer-card border rounded mb-2 text-on-bg-primary p-2"
        >
          <div className="d-flex align-items-center justify-content-between gap-2">
            <div className="flex-shrink-1" style={{ minWidth: 0 }}>
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex justify-content-between align-items-start w-100">
                  <span
                    className={`text-truncate d-block ${
                      viewportSize[0] <= VIEWPORT_LG
                        ? 'font-extra-small'
                        : 'fs-6'
                    }  fw-bold text-on-bg-primary`}
                  >
                    {nameOffer}
                  </span>
                </div>
              </div>
            </div>

            {IS_COMPANY ? (
              visible ? (
                <ActiveBadge title={t('this_offer_is_activated')} />
              ) : (
                <DesactiveBadge />
              )
            ) : (
              <></>
            )}
            <div className="d-flex aling-items-center gap-1 flex-shrink-0">
              {IS_HIRING_ADVISOR ? (
                visible ? (
                  <ActiveBadge title={t('this_offer_is_activated')} />
                ) : (
                  <DesactiveBadge title={''} />
                )
              ) : (
                <></>
              )}
              {!props?.on && (
                <Badge className="bg-bg-danger text-on-bg-danger rounded-pill p-2 d-flex align-items-center gap-1">
                  <XDangerIcon />
                  <span>Finalizada</span>
                </Badge>
              )}
              {isFavoriteMatch && <MatchBadgeIcon />}
            </div>
          </div>

          <Divider className="bg-on-bg-Tertiary w-100 mt-2 mb-2" />

          <div
            className={`${
              viewportSize[0] <= VIEWPORT_LG ? 'font-extra-small' : ''
            } d-flex flex-column gap-1 mb-2`}
          >
            <div className="d-flex align-items-start gap-1 d-none">
              <HouseAndBuildingIcon fill="#004949" width={16} height={16} />
              <span className="text-on-bg-secondary font-small-2">
                {t('company')}:
              </span>
              <span className="font-small-2">{name ?? 'No dispobible'}</span>
            </div>

            <div className="d-flex align-items-start gap-1">
              <BriefcaseClockIcon fill="#004949" width={16} height={16} />
              <span className="text-on-bg-secondary font-small-2">
                {t('position')}:
              </span>
              <span className="font-small-2">{renderPosition[typeUser]}</span>
            </div>
            <div className="d-flex align-items-start gap-1">
              <CalendarIcon fill="#004949" width={16} height={16} />
              <span className="text-on-bg-secondary font-small-2">
                {t('published')}:
              </span>
              <span className="font-small-2">
                {transformDate({ date: dateCreateOffer })}
              </span>
            </div>
            {IS_COMPANY && date_estimated_hiring && (
              <div className="d-flex align-items-start gap-1">
                <ClockIcon fill="#004949" width={16} height={16} />
                <span className="text-on-bg-secondary font-small-2">
                  {t('estimated_hiring_v2')}:
                </span>
                <span className="font-small-2">
                  {transformDate({
                    date: transformDate({ date: dateEstimatedHiring }),
                  })}
                </span>
              </div>
            )}
            {IS_HIRING_ADVISOR ||
              (!isJuniorView && (
                <div className="d-flex align-items-start gap-1">
                  <CashSmallIcon fill="#004949" width={16} height={16} />
                  <span className="text-on-bg-secondary font-small-2">
                    {t('salary_offered')}:
                  </span>
                  <span className="font-small-2">
                    {formatCurrency({
                      amount: String(renderStartingAmount[typeUser]),
                      symbol: coin?.symbol ?? coinOutside?.symbol,
                      short_name:
                        final_amount === 0
                          ? coin?.short_name ?? coinOutside?.short_name
                          : '',
                    })}
                    {renderFinalAmount[typeUser] !== 0 && (
                      <>
                        {' '}
                        -{' '}
                        {formatCurrency({
                          amount: String(renderFinalAmount[typeUser]),
                          symbol: coin?.symbol ?? coinOutside?.symbol,
                          short_name:
                            coin?.short_name ?? coinOutside?.short_name,
                        })}
                      </>
                    )}{' '}
                  </span>
                </div>
              ))}
          </div>

          {renderButtons[typeUser]}
          {(IS_RECRUITER || IS_TALENT || IS_ADMIN) && (
            <div className="d-flex justify-content-center align-items-center mt-3">
              <Link
                to={
                  IS_ADMIN
                    ? `/offer-detail-admin/${offert_id}`
                    : `/offer-management/${id || offert_id}`
                }
                className="btn-bg-CTA-primary text-on-bg-primary"
              >
                {t('review_offer')}
              </Link>
              <ArrowRigthIcon />
            </div>
          )}
        </div>
      </div>
      {IS_HIRING_ADVISOR && (
        <AssignCompanyModal
          offerId={id || offert_id}
          modalId={`assignCompanyModal-${id || offert_id}`}
        />
      )}
    </>
  ) : (
    <div className="position-relative">
      {isLoadingAcceptJobOffer && (
        <div className="position-absolute bg-blur">
          <div className="position-absolute loader-containter">
            <Loader />
          </div>
        </div>
      )}
      <div
        style={{
          width:
            viewportSize[0] <= VIEWPORT_LG &&
            window.location.pathname === PRIVATE_ROUTES.list_of_offers
              ? '350px'
              : isMoreTwoTalents
              ? ''
              : viewportSize[0] <= VIEWPORT_LG
              ? '100%'
              : IS_RECRUITER || IS_ADMIN
              ? '500px'
              : '600px',
        }}
        className="hover-job-offer-card border rounded mb-2 text-on-bg-primary p-2"
      >
        <div className="d-flex align-items-start justify-content-between">
          <div
            className={`d-flex flex-column ${
              IS_RECRUITER || IS_ADMIN ? 'w-100' : ''
            }`}
          >
            <div>
              <div className="d-flex align-items-center gap-3">
                {logo ? (
                  <img
                    src={logo}
                    width={58}
                    height={48}
                    className="rounded-pill"
                    style={{
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <Circle
                    className="bg-bg-tertiary p-4"
                    width="64px"
                    height="64px"
                  >
                    <StoreIcon />
                  </Circle>
                )}

                <div className="d-flex justify-content-between align-items-start w-100">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center justify-content-between">
                      <h1 className="fs-4 fw-bold text-on-bg-primary">
                        {renderPosition[typeUser] || NOT_AVAILABLE}
                      </h1>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className={`${
                          viewportSize[0] <= VIEWPORT_LG
                            ? 'font-extra-small'
                            : 'font-small'
                        } inline-text`}
                      >
                        {IS_TALENT ||
                          (IS_ADMIN && `${name || companies_simple_name} | `)}
                        {company_sector?.name || companies_simple_sector?.name}
                      </span>
                      {hutrit_next || isJuniorView ? (
                        <img src={hutrit_next_banner_icon} width={100} />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  {IS_ADMIN && !isFastofferHutritNext && (
                    <div className="d-flex align-items-center gap-2">
                      <Button
                        onClick={() => removeOfferMutate({ id })}
                        className="border border-danger-pressed"
                      >
                        {isLoadingRemoveOffer ? (
                          <Loader />
                        ) : (
                          <span className="text-danger-pressed">Eliminar</span>
                        )}
                      </Button>
                      <Button
                        onClick={() =>
                          handleVisibleOffer({
                            id,
                            visible,
                            companyId: company?.id,
                          })
                        }
                      >
                        {isLoadingVisibleOffer ? (
                          <Loader />
                        ) : visible ? (
                          'Ocultar'
                        ) : (
                          'Mostrar'
                        )}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center gap-2">
            {IS_RECRUITER &&
              (userDataIsLoading ? (
                <span className="inline-text">Generando link...</span>
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center cursor-pointer"
                  onClick={() => {
                    Toast({ title: 'Invitación copiada exitosamente' })
                    copyClipboard(
                      INVITATION_CODE_ORIGIN,
                      `/list-of-public-vacancies/${id}/${tmCode}`
                    )
                  }}
                >
                  <span className="btn-bg-CTA-primary text-on-bg-primary font-small-2 inline-text text-decoration-underline">
                    Copiar invitación
                  </span>
                  <ArrowRigthIcon />
                </div>
              ))}
            {IS_TALENT && !showProcessButton && (
              <div className="d-flex justify-content-center align-items-center">
                <Link
                  to={
                    IS_ADMIN
                      ? `/offer-detail-admin/${offert_id}`
                      : `/offer-management/${id || offert_id}`
                  }
                  className="btn-bg-CTA-primary text-on-bg-primary font-small-2 inline-text"
                >
                  {t('review_offer')}
                </Link>
                <ArrowRigthIcon />
              </div>
            )}
            {!IS_HIRING_ADVISOR && (
              <>
                {offer?.on ? (
                  <div className="d-none d-lg-flex align-items-center gap-2 overflow-auto">
                    {offerDate === today &&
                      !accept &&
                      offer_status_id !== 2 &&
                      active && (
                        <span className="badge bg-bg-Success text-on-bg-Success rounded-pill p-2 d-flex align-items-center gap-1">
                          <GlittersIcon />{' '}
                          <span className="d-lg-flex d-none">{t('new')}</span>
                        </span>
                      )}
                    {today > offerDate &&
                      offer_status_id !== 2 &&
                      !accept &&
                      active && (
                        <span className="badge bg-bg-warning  text-on-bg-warning rounded-pill p-2 d-flex align-items-center gap-1">
                          <EarringStatusIcon />{' '}
                          <span className="d-lg-flex d-none">
                            {t('earring')}
                          </span>
                        </span>
                      )}
                    {accept && active && (
                      <span className="badge bg-bg-CTA-primary-selected  text-on-bg-CTA-primary-selected rounded-pill p-2 d-flex align-items-center gap-1">
                        <ProgressStatusIcon />{' '}
                        <span className="d-lg-flex d-none">
                          {t('in_progress')}
                        </span>
                      </span>
                    )}
                    {offer_status_id === 2 && active && (
                      <span className="badge bg-bg-danger  text-on-bg-danger rounded-pill p-2 d-flex align-items-center gap-1">
                        <XDangerIcon />{' '}
                        <span className="d-lg-flex d-none">
                          {t('rejectedTwo')}
                        </span>
                      </span>
                    )}
                    {!active && (
                      <span className="badge bg-bg-danger  text-on-bg-danger rounded-pill p-2 d-flex align-items-center gap-1">
                        <XDangerIcon />{' '}
                        <span className="d-lg-flex d-none">Finalizado</span>
                      </span>
                    )}
                    {offer?.on && (
                      <span className="badge bg-bg-danger text-on-bg-danger rounded-pill p-2 d-flex align-items-center gap-1">
                        <XDangerIcon />{' '}
                        <span className="d-lg-flex d-none">Finalizada</span>
                      </span>
                    )}
                  </div>
                ) : (
                  <div className="me-3">
                    <DesactiveBadge title="Esta oferta fue desactivada" />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <Divider className="bg-on-bg-Tertiary w-100 mt-2 mb-2" />
        {!isFastofferHutritNext && (
          <div
            className={`${
              viewportSize[0] <= VIEWPORT_LG ? 'font-extra-small' : ''
            } d-flex flex-column gap-1 mb-2`}
          >
            <div className="d-flex align-items-center gap-1">
              <MoneyIcon fill="#004949" width={16} height={16} />
              <span className="text-on-bg-secondary font-small-2">
                {IS_TALENT && hutrit_next
                  ? 'Salario bruto inicial mensual:'
                  : renderPosition[typeUser]
                  ? 'Salario bruto anual:'
                  : 'Salario bruto inicial mensual:'}
              </span>
              <span className="font-small-2">
                {formatCurrency({
                  amount: String(renderStartingAmount[typeUser] ?? '300'),
                  symbol: coin?.symbol ?? coinOutside?.symbol ?? '$',
                  short_name: hutrit_next
                    ? 'USD'
                    : final_amount === 0
                    ? coin?.short_name ?? coinOutside?.short_name
                    : '',
                })}
                {renderFinalAmount[typeUser] !== 0 &&
                  renderStartingAmount[typeUser] && (
                    <>
                      {' '}
                      -{' '}
                      {formatCurrency({
                        amount: String(renderFinalAmount[typeUser]),
                        symbol: coin?.symbol ?? coinOutside?.symbol,
                        short_name: coin?.short_name ?? coinOutside?.short_name,
                      })}
                    </>
                  )}{' '}
              </span>
            </div>
            {renderModality[renderModalityOffer?.[typeUser]?.[0]?.modality?.id]}
            <div className="d-flex align-items-center gap-1">
              <ClockIcon fill="#004949" width={16} height={16} />
              <span className="text-on-bg-secondary font-small-2">
                Recibido:
              </span>
              <span className="font-small-2">
                {transformDate({
                  date: transformDate({ date: dateCreateOffer }),
                })}
              </span>
            </div>
          </div>
        )}
        {isFastofferHutritNext && (
          <div
            className={`${
              viewportSize[0] <= VIEWPORT_LG ? 'font-extra-small' : ''
            } d-flex flex-column gap-1 mb-2`}
          >
            <div className="d-flex align-items-center gap-1">
              <span className="text-on-bg-secondary font-small-2">
                Nombre de la empresa:
              </span>
              <span className="font-small-2">
                {props?.contact_information_offer?.representative_name}
              </span>
            </div>
            <div className="d-flex align-items-center gap-1">
              <span className="text-on-bg-secondary font-small-2">
                Telefono:
              </span>
              <span className="font-small-2">
                {props?.contact_information_offer?.phone}
              </span>
            </div>
            <div className="d-flex align-items-center gap-1">
              <span className="text-on-bg-secondary font-small-2">Correo:</span>
              <span className="font-small-2">
                {props?.contact_information_offer?.email}
              </span>
            </div>
            <div className="d-flex flex-column gap-1">
              <span className="text-on-bg-secondary font-small-2">
                Sobre la empresa:
              </span>
              <span className="font-small-2">{props?.description}</span>
            </div>
          </div>
        )}
        {!isFastofferHutritNext && (
          <div className="position-relative  w-100 d-flex">
            <div className="d-flex align-items-center mt-2 mb-3 w-100 overflow-auto">
              {elementsToShow?.map(({ skills_categori, id }) => (
                <Badge
                  key={id}
                  className="border border-on-bg-CTA-primary-selected text-on-bg-CTA-primary-selected rounded-pill me-2"
                  style={{
                    width: 'max-content',
                    height: 'max-content',
                  }}
                >
                  {skills_categori?.skill?.name || NOT_AVAILABLE}
                </Badge>
              ))}
              {showSkills && (
                <Badge
                  className="bg-bg-CTA-complementary-pressed  text-on-bg-primary rounded-pill me-2"
                  style={{
                    width: 'max-content',
                    height: 'max-content',
                  }}
                >
                  {`+${renderSkills?.[typeUser]?.length - 3}`}
                </Badge>
              )}
              <div className="w-100 d-lg-flex justify-content-end d-none">
                {renderButtons[typeUser]}
              </div>
            </div>

            {IS_ADMIN && (
              <Button
                onClick={() => navigate(`/offer-detail-admin/${offert_id}`)}
              >
                <span className="inline-text"> {t('review_offer')}</span>
              </Button>
            )}
          </div>
        )}
        {isFastofferHutritNext && (
          <div className="position-relative  w-100 d-flex">
            <div className="d-flex align-items-center mt-2 mb-3 w-100 overflow-auto">
              {renderSkills?.[typeUser]?.map(({ skills_categori, id }) => (
                <Badge
                  key={id}
                  className="border border-on-bg-CTA-primary-selected text-on-bg-CTA-primary-selected rounded-pill me-2"
                  style={{
                    width: 'max-content',
                    height: 'max-content',
                  }}
                >
                  {skills_categori?.skill?.name || NOT_AVAILABLE}
                </Badge>
              ))}
            </div>

            {IS_ADMIN && !isFastofferHutritNext && (
              <Button
                onClick={() => navigate(`/offer-detail-admin/${offert_id}`)}
              >
                <span className="inline-text"> {t('review_offer')}</span>
              </Button>
            )}
          </div>
        )}

        {!IS_COMPANY && !IS_HIRING_ADVISOR && (
          <div className="w-100 d-lg-none d-flex align-items-end w-100 justify-content-end">
            {renderButtons[typeUser]}
          </div>
        )}
      </div>
    </div>
  )
}

export default JobOfferCard
